// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__QOY0E","navItem":"Nav_navItem__nz1w9","navIcon":"Nav_navIcon__AS1eH","navItemTitle":"Nav_navItemTitle__bA2CS","noViewNav":"Nav_noViewNav__hUc0O"};